import { BACK_URL } from "./app_static";

export const fetchCmsPublicPage = async (pageVarName) => {
  const res = await fetch(`${BACK_URL}/api/cms/public/${pageVarName}`);
  if (!res.ok) {
    throw new Error(`HTTP ${res.status}`);
  }

  const payload = await res.json();
  if (!payload?.success || !payload?.data) {
    throw new Error("Invalid CMS payload");
  }

  return {
    pageLabel: payload?.data?.page?.label || "",
    texts: payload?.data?.texts || [],
  };
};

export const interpolateCmsText = (text, replacements = {}) => {
  let output = String(text || "");
  Object.entries(replacements).forEach(([key, value]) => {
    output = output.replaceAll(`{{ ${key} }}`, String(value ?? ""));
  });

  return output;
};

export const buildCmsDocsByVar = (texts = [], replacements = {}) => {
  const docsByVar = {};

  texts.forEach((item) => {
    if (!item?.var_name) return;

    docsByVar[item.var_name] = {
      ...item,
      body: interpolateCmsText(item.body, replacements),
    };
  });

  return docsByVar;
};

export const stripHtml = (html) => {
  return String(html || "").replace(/<[^>]*>/g, "").trim();
};
